export const loadingIndicatorGif = `https://bauer.a.bigcontent.io/v1/static/loading-indicator`;
